import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "../public/vfs_fonts.js";
import { fish, emptyLogo } from './svg';

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
    metropolis: {
        normal: 'Metropolis-Regular.otf'
    },
};

const A4 = [29.7 * 28.3465, 21.0 * 28.3465];

export default class Pdf {
    constructor(fishMovements, textBlocks) {
        this.fishMovements = fishMovements;
        this.textBlocks = textBlocks;
        this.logo2 = null;
    }

    setLogo2(logoDataURI) { 
        this.logo2 = logoDataURI;
    }

    getLogo1() {
        return {
            width: '50%',
            svg: fish,
            fit: [(A4[0]/2) - 50, (A4[1] / 2) - 50],
            margin: [0, 50, 0, 0]
        };
    }

    getLogo2() {
        if (!this.logo2) {
            return {
                width: '50%',
                svg: emptyLogo,
                fit: [(A4[0]/2) - 50, (A4[1] / 2) - 50],
            }
        }

        return {
            image: this.logo2,
            fit: [(A4[0]/2) - 50, (A4[1] / 2) - 50],
        };
    }

    getMovementDescriptionsTable(width) 
    {
        return {
            width,
            alignment: 'left',
            layout: {
                defaultBorder: false,
                paddingLeft: () => 5,
                paddingRight: () => 5,
            },
            fontSize: 13,
            margin: [10, 0, 10, 0],
            table: { 
                body: [
                    [{ alignment: "right", noWrap: true, text: 'Moving head'        }, '..........', this.fishMovements.movingHead],
                    [{ alignment: "right", noWrap: true, text: 'Moving tail'        }, '..........', this.fishMovements.movingTail],
                    [{ alignment: "right", noWrap: true, text: 'Moving head & tail' }, '..........', this.fishMovements.movingHeadTail],
                    [{ alignment: "right", noWrap: true, text: 'Curling sides'      }, '..........', this.fishMovements.curlingSides],
                    [{ alignment: "right", noWrap: true, text: 'Turns over'         }, '..........', this.fishMovements.turnsOver],
                    [{ alignment: "right", noWrap: true, text: 'Motionless'         }, '..........', this.fishMovements.motionless],
                    [{ alignment: "right", noWrap: true, text: 'Curls up entirely'  }, '..........', this.fishMovements.curlsUpEntirely],
                ]
            }
        }
    }

    getTextBlock1() {
        return {
            width: '50%',
            text: this.textBlocks.text1,
            margin: [10, 10, 10, 40]
        };
    }

    getTextBlock2() {
        return {
            width: '50%',
            text: this.textBlocks.text2,
            margin: [10, 0, 10, 20]
        };
    }

    getTextBlock3() {
        return {
            width: '50%',
            text: this.textBlocks.text3,
            margin: [10, 20, 10, 0]
        };
    }

    generate() {
        const pdf = {
            pageSize: 'A4',
            pageOrientation: 'landscape',
            defaultStyle: {
                fontSize: 14,
                color: '#ea502f',
                font: 'metropolis'
            },
            compress: false,
            info: { 
                title: 'Psychic Fish',
                subject: 'Adapted from the Animal Research Nexus Psychic Fish',
                author: 'tinyurl.com/DIYPsychicFish',
            },
            content: [
                // Page 1 - Logos
                {
                    alignment: 'center',
                    columns: [
                        this.getLogo2(),
                        this.getLogo2()
                    ]
                },
                {
                    alignment: 'center',
                    columns: [
                        this.getLogo1(),
                        Object.assign({}, this.getLogo1(), { pageBreak: 'after'}),
                    ],
                },
                // Page 2 - Descriptions
                {
                    alignment: 'center',
                    columnGap: 10,
                    columns: [
                        this.getMovementDescriptionsTable('50%'),
                        this.getMovementDescriptionsTable('50%'),
                    ]
                },
                {
                    absolutePosition: { x: 30, y: (A4[1]/2) },
                    stack: [
                        {
                            alignment: 'center',
                            columnGap: 30,
                            columns: [
                                this.getTextBlock1(),
                                this.getTextBlock1()
                            ]
                        },
                        {
                            alignment: 'center',
                            columnGap: 30,
                            columns: [
                                this.getTextBlock2(),
                                this.getTextBlock2()
                            ]
                        },
                        {
                            alignment: 'center',
                            columnGap: 30,
                            columns: [
                                this.getTextBlock3(),
                                this.getTextBlock3()
                            ]
                        },
                    ]
                },
                {
                    fontSize: 10,
                    alignment: 'center',
                    columnGap: 10,
                    color: '#999999',
                    columns: [
                        { text: 'Adapted from the Animal Research Nexus Psychic Fish', },
                        { text: 'Adapted from the Animal Research Nexus Psychic Fish', },
                    ],
                    absolutePosition: { x: 20, y: (A4[1] - 70) }
                }
            ]
        };

        return pdfMake.createPdf(pdf);
    }
}
